import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Config } from 'app/config.const';
import { CategoriaEvento } from 'app/model/categoria_evento';
import { flatMap } from 'rxjs/operators';
import { RESTArray } from '../angular-rest';


@Injectable()
export class ImpostazioniGenerali extends RESTArray<CategoriaEvento> {

    constructor($http: HttpClient) {
        super(
            $http,
            `${Config.baseURL}/impostazioni/colori`,
            (h, u, r) => new CategoriaEvento(h, u, r),
            t => ({ id: t.categoria })
        );
    }

    // Il reset non fa parte del modello dell'array (la delete è di solito usata
    // per cancellare elementi), ma in questo caso fa comodo averla ed è facile da fare.
    reset() {
        this.mapRequest(
            this.$http.delete(this.uri).pipe(
				flatMap(d => this.$http.get<any[]>(this.uri))
			)
        );
    }
}




// WEBPACK FOOTER //
// ./src/app/model/impostazioni_generali.ts